import { render } from "./DismissibleAlert.vue?vue&type=template&id=70d199d0&scoped=true&ts=true"
import script from "./DismissibleAlert.vue?vue&type=script&lang=ts"
export * from "./DismissibleAlert.vue?vue&type=script&lang=ts"

import "./DismissibleAlert.vue?vue&type=style&index=0&id=70d199d0&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d199d0"]])

export default __exports__